export default __webpack_public_path__ + "static/mac-da34acc384f5b5b60dd676ec5d13a91c.png";